module.exports = __webpack_public_path__ + "assets/img/original-logo.7293ec71.svg";